import { useEffect, useRef, useState } from "react";
import classes from "./EstudianteRecordatorio.module.css";
import {
  EnviaDatosANuevoServicio,
  FechaMMMDeString,
} from "../../Funciones/Funciones";
import useToken from "../login/useToken";

function RecordatorioEstudiante(props) {
  const [isLoading, setIsLoading] = useState(false);
  const recodatorioRef = useRef();
  const token = useToken().token;
  const idUsu = token.Id;
  const [loadedRecordatorios, setLoadedRecordatorios] = useState([]);
  const [recarga, setRecarga] = useState(false);
  const [editando, setEditando] = useState(false);
  const [IDRecEditando, setIDRecEditando] = useState(0);

  useEffect(() => {
    setIsLoading(true);
    setRecarga(false);
    const datos = {
      IDEstHab: props.datosRecordatorio.IDEst,
      Tipo: 1,
    };
    EnviaDatosANuevoServicio(
      "ObtenRecordatorios",
      datos,
      respServ1,
      setIsLoading,
      null,
      idUsu,
    );
  }, [props.datosRecordatorio.IDEst, idUsu, recarga]);

  function respServ1(resp) {
    setLoadedRecordatorios(resp.recordatorios);
  }

  function CancelaRecordatorio(ev) {
    ev.preventDefault();
    props.setMostrarAgregaRecordatorio(false);
  }

  function respServ(resp) {
    if (resp.Error === "SI") {
      props.setDialogoOK({
        texto: "Error: " + resp.DESCERROR,
        mostrandoError: true,
        recargar: false,
        cerrarVentana: "",
      });
      props.setMuestraDialogoOK(true);
    } else {
      setRecarga(true);
    }
  }

  const submitRecordatorio = async (ev) => {
    ev.preventDefault();
    if (recodatorioRef.current.value === "") {
      props.setDialogoOK({
        texto: "No hay recordatorio que agregar",
        mostrandoError: true,
        recargar: false,
        cerrarVentana: "",
      });
      props.setMuestraDialogoOK(true);
    } else {
      if (!editando) {
        const datos = {
          IDEstHab: props.datosRecordatorio.IDEst,
          Recordatorio: recodatorioRef.current.value,
          Tipo: 1,
        };
        EnviaDatosANuevoServicio(
          "NuevoRecordatorio",
          datos,
          respServ,
          setIsLoading,
          null,
          idUsu,
        );
      } else {
        const datos = {
          IDRec: IDRecEditando,
          Recordatorio: recodatorioRef.current.value,
        };
        EnviaDatosANuevoServicio(
          "ModificaRecordatorio",
          datos,
          respServ3,
          setIsLoading,
          null,
          idUsu,
        );
      }
    }
  };

  function respServ3(resp) {
    if (resp.Error === "SI") {
      props.setDialogoOK({
        texto: "Error: " + resp.DESCERROR,
        mostrandoError: true,
        recargar: false,
        cerrarVentana: "",
      });
      props.setMuestraDialogoOK(true);
    } else {
      setEditando(false);
      setRecarga(true);
    }
  }

  function modificaRecordatorio(ev) {
    ev.preventDefault();
    const recordatorio = loadedRecordatorios.filter(
      (rec) => rec.IDRec === ev.target.id,
    );
    recodatorioRef.current.value = recordatorio[0].Descripcion;
    setEditando(true);
    setIDRecEditando(recordatorio[0].IDRec);
  }

  function eliminaRecordatorio(ev) {
    ev.preventDefault();
    const datos = {
      IDRec: ev.target.id,
    };
    EnviaDatosANuevoServicio(
      "EliminaRecordatorio",
      datos,
      respServ2,
      setIsLoading,
      null,
      idUsu,
    );
  }

  function respServ2(resp) {
    if (resp.Error === "SI") {
      props.setDialogoOK({
        texto: "Error: " + resp.DESCERROR,
        mostrandoError: true,
        recargar: false,
        cerrarVentana: "",
      });
      props.setMuestraDialogoOK(true);
    } else {
      setRecarga(true);
    }
  }

  /***********************************************************************/
  /************************ RENDER ***************************************/
  /***********************************************************************/
  if (isLoading) {
    return (
      <section className={classes.modal}>
        <h1>Loading...</h1>
      </section>
    );
  }
  return (
    <div className={classes.modal}>
      <div className={classes.contBotTop}>
        <button className={classes.botTop} onClick={CancelaRecordatorio}>
          <i className="fas fa-times"></i>
        </button>
      </div>
      <h1 className={classes.h1Rec}>Recordatorios</h1>
      <label className={classes.labelP}>{props.datosRecordatorio.Nombre}</label>
      <div className={classes.contTabla}>
        <table className={classes.tabla}>
          <thead className={classes.th}>
            <tr>
              <td className={classes.ren1Col1}>INICIO</td>
              <td className={classes.ren1Col2}>DESCRIPCION</td>
              <td className={classes.ren1Col3}>ACCION</td>
            </tr>
          </thead>
          <tbody>
            {loadedRecordatorios.map((recordatorio) => {
              return (
                <tr key={recordatorio.IDRec}>
                  <td>{FechaMMMDeString(recordatorio.FechaAlta)}</td>
                  <td>{recordatorio.Descripcion}</td>
                  <td className={classes.tabbot}>
                    <button
                      onClick={modificaRecordatorio}
                      id={parseInt(recordatorio.IDRec)}
                      className={classes.innbtn}
                    >
                      {props.nivel === 1 ? (
                        <i
                          id={parseInt(recordatorio.IDRec)}
                          className="fas fa-pencil-alt"
                        ></i>
                      ) : (
                        <i
                          id={parseInt(recordatorio.IDRec)}
                          className="fas fa-eye"
                        ></i>
                      )}
                    </button>
                    {props.nivel === 1 ? (
                      <button
                        onClick={eliminaRecordatorio}
                        id={parseInt(recordatorio.IDRec)}
                        className={classes.innbtn}
                      >
                        <i
                          id={parseInt(recordatorio.IDRec)}
                          className="fas fa-times"
                        ></i>
                      </button>
                    ) : null}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <h1 className={classes.h1AddRec}>Agregar recordatorio</h1>
      <form>
        <input
          type="text"
          ref={recodatorioRef}
          placeholder="¿Cual es el recordatorio?"
          className={classes.textareaNE}
        ></input>
        {props.nivel === 1 && (
          <button className={classes.botSave} onClick={submitRecordatorio}>
            {editando ? (
              <i className="fas fa-save"></i>
            ) : (
              <i className="fas fa-plus"></i>
            )}
          </button>
        )}
      </form>
    </div>
  );
}

export default RecordatorioEstudiante;
